import IJob from '../interfaces/IJob';
import IRoleType from '../interfaces/IRoleType';

export default function stackFilterFunciton(job: IJob, selected: IRoleType[]) {
  return job.roleTypes.some((type: IRoleType) =>
    selected.some(selected => selected.uid === type.uid)
  );
}
